export default __webpack_public_path__ + "static/media/portfolio-details.34ff5eef.png";